import React from "react";
import { Button } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import FocusedFlowPage from "components/FocusedFlowPage";
import { useNavigate } from "react-router-dom";
import { usePatient } from "./PatientProvider";
import { useEffect } from "react";
import { BIOBANK_ROUTES, BIOBANK_SUB_ROUTES } from "../../../constants/routes";

const GettingStarted = () => {
  const navigate = useNavigate();
  const { patientData, setPatientData } = usePatient();

  useEffect(() => {
    // If no patient data, redirect back to search
    if (!patientData) {
      navigate(BIOBANK_ROUTES.PARTICIPANT_CHECKIN);
    }
  }, [patientData, navigate]);

  const handleContinue = () => {
    // Pass patient data to general-info page
    navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_GENERAL, {
      state: {
        patient: patientData,
      },
    });
  };

  return (
    <FocusedFlowPage
      title="Get Started"
      subtitle="Please click continue button and hand the tablet to the patient to complete the next two steps."
      onClose={() => navigate(BIOBANK_ROUTES.PARTICIPANT_CHECKIN)}
      maxWidth={640}
      actions={[
        <Button
          key="back"
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_CHECKIN_WIZARD_APPOINTMENT, { state: { user: patientData } })}
        >
          Back
        </Button>,
        <Button
          key="continue"
          variant="contained"
          endIcon={<ArrowForward />}
          onClick={() => handleContinue()}
        >
          Continue
        </Button>,
      ]}
    />
  );
};

export default GettingStarted;
